<template>
  <div class="goods-detail">
    <div class="title">{{ $t('product.singleProductData') }}</div>
    <div class="table">
      <div class="weight-box">
        <div class="item">{{ $t('kol.i18n-0000011') }}</div>
        <div class="item item1">
          {{ `${$props.receiveDays ? $props.receiveDays + $t('estimation.i18n-0000003') : '--'}` }}
        </div>
      </div>
      <div class="weight-box">
        <div class="item">{{ $t('common.productSaleCount') }}</div>
        <div class="item item1">{{ $props.saleCount || '--' }}</div>
      </div>
      <div class="weight-box">
        <div class="item">{{ $t('common.weightHaveUnit') }}</div>
        <div class="item item1">{{ $props.weight || '--' }}</div>
      </div>
      <div class="weight-box">
        <div class="item item2">{{ $t('common.volume') }}</div>
        <div class="item item1 item2">{{ $props.volume || '--' }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
const $props = defineProps({
  weight: {
    type: String,
    default: '',
  },
  volume: {
    type: String,
    default: '',
  },
  saleCount: {
    type: Number,
    default: 0,
  },
  receiveDays: {
    type: Number,
    default: 0,
  },
})
</script>

<style lang="scss" scoped>
.goods-detail {
  padding-bottom: 12px;

  // border-bottom: 1px solid var(--line-light-gray-color);
  .title {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);
    margin-bottom: 12px;
  }

  .table {
    border-radius: 8px;
    width: 640px;
    border: 1px solid #dadee6;
    color: var(--black-color-9);

    .weight-box {
      height: 45px;
      width: 640px;
      display: flex;
      justify-content: space-between;

      .item {
        width: 320px;
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        font-weight: 300;
        border-bottom: 1px solid #dadee6;
        padding: 0 12px;
        border-right: 1px solid #dadee6;
        box-sizing: border-box;
      }

      .item1 {
        text-align: right;
        border-right: none;
      }

      .item2 {
        border-bottom: none;
      }
    }
  }
}
</style>
